<template>
  <!-- Modal -->
  <div
    class="modal fade"
    id="modal-taraf-hesab"
    tabindex="-1"
    role="dialog"
    aria-labelledby="TarafModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content rounded text-dark">
        <div class="modal-header bg-primary text-white rounded-top p-2">
          <h5 class="modal-title" id="TarafModalLabel">لیست طرف حساب ها</h5>
          <button
            type="button"
            class="close m-0 p-1"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span class="text-white" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- شروع تب حساب ها -->
          <div class="col p-0">
            <!-- تب های کد حساب -->
            <ul class="nav nav-tabs">
              <!-- تب لیست حساب ها -->
              <li class="nav-item activeNav rounded-top">
                <a
                  href="#tabTarafHesab-list"
                  id="home-tab"
                  class="
                    nav-link
                    active
                    d-flex
                    justify-content-between
                    align-items-center
                  "
                  data-toggle="tab"
                >
                  لیست طرف حساب ها ( {{ TbPersonDataFilter.length | numFormat }} مورد
                  )
                </a>
              </li>
              <!-- تب درختواه حساب ها -->
              <!-- <li class="nav-item rounded-top">
                <a
                  href="#tabHesab-tree"
                  id="profile-tab"
                  class="nav-link d-flex justify-content-between align-items-center"
                  data-toggle="tab"
                >
                  درختواره حساب ها
                </a>
              </li> -->
            </ul>

            <!-- بدنه تب های حساب ها -->
            <div class="tab-content rounded shadow z-depth-1 p-1">
              <!-- بدنه تب لیست حساب ها -->
              <div
                class="tab-pane fade show active w-100"
                id="tabTarafHesab-list"
              >
                <!-- جدول محتویات -->
                <div class="row p-2">
                  <div
                    id="TbPersonData"
                    class="table-responsive"
                    style="max-height: 280px; overflow-y: auto"
                  >
                    <!-- <b-table
                      striped
                      hover
                      :items="TbPersonData"
                      :fields="TbPersonDataTitel"
                    ></b-table> -->
                    <table
                      class="
                        table table-bordered table-sm
                        text-center
                        table-font-size
                      "
                    >
                      <!-- سربرگ جدول -->
                      <thead>
                        <td
                          class="bg-primary-light"
                          style="
                            position: sticky;
                            top: -1px;
                            border: 1px solid #dee2e6;
                          "
                        >
                          ردیف
                        </td>
                        <td
                          class="bg-primary-light"
                          style="
                            position: sticky;
                            top: -1px;
                            border: 1px solid #dee2e6;
                          "
                        >
                          کد
                        </td>
                        <td
                          class="bg-primary-light"
                          style="
                            position: sticky;
                            top: -1px;
                            border: 1px solid #dee2e6;
                          "
                        >
                          عنوان
                        </td>
                        <td
                          class="bg-primary-light"
                          style="
                            position: sticky;
                            top: -1px;
                            border: 1px solid #dee2e6;
                          "
                        >
                          عنوان کامل
                        </td>
                        <td
                          class="bg-primary-light"
                          style="
                            position: sticky;
                            top: -1px;
                            border: 1px solid #dee2e6;
                          "
                        >
                          نوع
                        </td>
                      </thead>
                      <!-- بدنه جدول -->
                      <tbody>
                        <tr
                          v-for="(row, index) in getListDataPaging"
                          :key="row.NPerID"
                          :class="{ selRow: selectRow.NPerID == row.NPerID }"
                          v-on:click="selectRowVal(row.NPerID, row.NPerName, row.NPerLastName, row.NPerType)"
                          v-on:dblclick="dblClickRow(row.NPerID, row.NPerName, row.NPerLastName, row.NPerType)"
                          v-bind:id="'traf-' + row.NPerID"
                          style="cursor: pointer;"
                        >
                          <td
                            style="
                              max-width: 50px;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                            "
                          >
                            {{ row.RowID }}
                          </td>
                          <td
                            style="
                              max-width: 120px;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                            "
                          >
                            {{ row.NPerID }}
                          </td>
                          <td
                            style="
                              max-width: 120px;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                            "
                          >
                            {{ row.NPerName }}
                          </td>
                          <td
                            style="
                              max-width: 120px;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                            "
                          >
                            {{ row.NPerLastName }}
                          </td>
                          <td
                            style="
                              max-width: 120px;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                            "
                          >
                            {{ row.NPerType }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <PaginationTarafHesab class="mt-2" v-bind:Name="'TaragHesab'" v-bind:CountRow="intCountRow"
                      v-bind:DataRepository="TbPersonDataFilter" v-on:ChangePage="ChangePage"></PaginationTarafHesab>
                </div>
              </div>

              <!-- بدنه تب درختواره حساب ها -->
              <!-- <div class="tab-pane fade w-100" id="tabHesab-tree">
                <div class="row">
                  
                  <mdb-treeview class="border-0 text-right" animated>
                    <mdb-treeview-item nested animated far title="افتتاحیه">
                      <mdb-treeview-item
                        far
                        icon="address-book"
                        title="حساب افتتاحیه"
                      />
                    </mdb-treeview-item>
                    <mdb-treeview-item far nested animated title="نقد و بانک">
                      <mdb-treeview-item
                        far
                        icon="address-book"
                        title="بانک ها"
                      />
                      <mdb-treeview-item
                        far
                        icon="address-book"
                        title="تنخواه گردان"
                      />
                    </mdb-treeview-item>
                  </mdb-treeview>
                  
                </div>
              </div> -->
            </div>
          </div>
          <!-- پایان تب حساب ها -->
        </div>
        <div class="modal-footer bg-primary-light p-2">
          <div class="col-6 flex-fill">
            <div class="input-group px-1">
              <input
                type="text"
                autocomplete="off"
                id="textSearchTarafHesab"
                placeholder="جستجو در کد و عنوان طرف حساب (Enter)  ثبت (F4)"
                class="form-control form-control-sm rounded-0"
                v-on:focus="$event.target.select()"
                v-on:keyup.enter="filterData($event.target.value, $event); $event.target.select()"
              />
              <div class="input-group-prepend rounded-0">
                <span
                  class="
                    input-group-text input-group-box-size
                    bg-primary
                    rounded-left
                    white-text
                  "
                >
                  <a v-on:click="filterData('Search')">
                    <i class="fas fa-search"></i>
                  </a>
                </span>
              </div>
            </div>
          </div>
          <div class="col-6 text-left">
            <button
              type="button"
              title="F4 انتخاب"
              class="btn btn-primary"
              v-on:click="SelectHesab()"
            >
              انتخاب طرف حساب (F4)
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              انصراف
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import {
//   mdbContainer,
//   mdbRow,
//   mdbIcon,
//   mdbTreeview,
//   mdbTreeviewItem,
//   mdbtable,
// } from "mdbvue";

import { BusEvent } from "../../../../../main.js";
import PaginationTarafHesab from "../../PublicComponents/Pagination.vue"

export default {
  components: {
    PaginationTarafHesab
  },
  data() {
    return {
      selectRow: {
        NPerID: 0,
        NPerName: "",
        NPerLastName: "",
        NPerType: 0,
      },

      // مربوط به صفحه بندی
      intPageNumber: 1,  // شماره صفحه در حال انتخاب
      intCountRow: 500,   // تعداد سطرها در هر صفحه
      intCountPage: 1,   // تعداد کل صفحه ها
      intCountRowShow: 1, // تعداد سطرهای مشاهده شده در صفحه - ممکن است صفحه 200 سطر کامل نباشد

      // ایندکس سطر در حال انتخاب
      indexRow: 0,
      // مخزن اصلی داده ها
      TbPersonData: [],
      // مخزن داده های فیلتر شده
      TbPersonDataFilter: [],
      NPerIDSearch: [],
    };
  },
  props: ['NAccType'],
  computed: {
    // نمایش اطلاعات با قابلیت صفحه بندی
    getListDataPaging() {
      if (this.TbPersonDataFilter.length > 0) {
        // شماره شروع رکورد
        let startRowIndex = this.intPageNumber == 1 ? 1 : (parseInt(this.intCountRow) * (parseInt(this.intPageNumber) - 1) + 1);
        let intCountRowLocal = this.intCountRow;
        // انتخاب رکوردهای صفحه مورد نظر
        let ListTemplate = [];
        ListTemplate = this.TbPersonDataFilter.filter(function (item) {
          return (item.RowID >= startRowIndex && item.RowID < (parseInt(startRowIndex) + parseInt(intCountRowLocal)))
        });
        // خروجی لیست صفحه مورد نظر
        return ListTemplate;
      } else {
        return [];
      }
    },
  },
  mounted() {
    // بررسی انصراف از نمایش مودال
    $("#modal-taraf-hesab").on("hidden.bs.modal", this.HideModal);
  },
  methods: {
    // رویداد تغییر صفحه از کامپاننت صفحه بندی
    ChangePage(value) {
      this.intPageNumber = value.pageNumber;
      this.intCountRow = value.countRow;
      this.intCountPage = value.countPage;
    },
    // لغو مودال کد حساب و طرف حساب
    HideModal() {
      // لحظه بسته شدن مودال
      if (this.selectRow.NPerID == 0) {
        this.$emit("HideModal", {
          NPerID: 0,
          NPerName: "",
          NPerLastName: "",
          NPerType: 0,
        });
      } else {
        this.$emit("HideModal", {
          NPerID: this.selectRow.NPerID,
          NPerName: this.selectRow.NPerName,
          NPerLastName: this.selectRow.NPerLastName,
          NPerType: this.selectRow.NPerType,
        });
      }
    },

    // جستجو در لیست حساب ها
    async filterData(searchValue, event) {
      if (searchValue === "Search") {
        searchValue =
          $("#textSearchTarafHesab").val() != ""
            ? $("#textSearchTarafHesab").val()
            : "";
      }

      // لغو فراخوانی جستجو در صورت کلیک فلش بالا و پایین
      try{
        if(event.key.toString() === "ArrowDown" || event.key.toString() === "ArrowUp"){
          $("#textSearchTarafHesab").select();
          return true;
        }
      } catch (e) {}

      if (searchValue != "") {
        // فیلتر اطلاعات بر اساس مقدار درج شده توسط کاربر
        this.TbPersonDataFilter =
          this.TbPersonData.filter(function(itme){
            return (itme.NPerID.toString().startsWith(searchValue) ||
              itme.NPerName.toString().includes(searchValue) ||
              itme.NPerLastName.toString().includes(searchValue) ||
              itme.NPerType.toString().startsWith(searchValue))
            });
        if(this.TbPersonDataFilter.length > 0){
          // درج شماره ردیف برای لیست
          this.TbPersonDataFilter = await this.$store.dispatch('setRowIDForList', this.TbPersonDataFilter);

          if(this.TbPersonDataFilter.length < this.indexRow) this.indexRow = 0;
          // ذخیره سطر پیدا شده
          this.selectRow.NPerID = this.TbPersonDataFilter[this.indexRow].NPerID;
          this.selectRow.NPerName = this.TbPersonDataFilter[this.indexRow].NPerName;
          this.selectRow.NPerLastName = this.TbPersonDataFilter[this.indexRow].NPerLastName;
          this.selectRow.NPerType = this.TbPersonDataFilter[this.indexRow].NPerType;
        }
      } else {
        this.TbPersonDataFilter = this.TbPersonData;
      }
    },

    // جستجو در لیست حساب ها
    searchData(searchValue, event) {
      if (searchValue != "") {
        // جستجوی مقدار درج شده توسط کاربر
        // و انتقال نمایش به سطر جستجو شده
        let index = this.TbPersonData.findIndex(
          (itme) =>
            itme.NPerID.toString().startsWith(searchValue) ||
              itme.NPerName.toString().includes(searchValue) ||
              itme.NPerLastName.toString().includes(searchValue) ||
              itme.SPerNationalId.toString().includes(searchValue)
        );
        if (index != -1) {
          let NPerID = this.TbPersonData[index].NPerID;
          $("#traf-" + NPerID).scrollintoview({
            duration: 500,
            //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
          });
          // ذخیره سطر پیدا شده
          this.selectRow.NPerID = NPerID;
          this.selectRow.NPerName = this.TbPersonData[index].NPerName;
          this.selectRow.NPerLastName = this.TbPersonData[index].NPerLastName;
          this.selectRow.NPerType = this.TbPersonData[index].NPerType;
        }
      } else {
        this.NPerIDSearch = [];
      }
    },

    async getTbPersonData() {
      this.TbPersonData = await this.$store.getters.getTbPersonData(this.NAccType);
      // درج شماره ردیف برای لیست
      this.TbPersonData = await this.$store.dispatch('setRowIDForList', this.TbPersonData);
      this.TbPersonDataFilter = this.TbPersonData;
    },

    dblClickRow(NPerID, NPerName, NPerLastName, NPerType) {
      this.selectRowVal(NPerID, NPerName, NPerLastName, NPerType);
      this.SelectHesab();
    },

    selectRowVal(NPerID, NPerName, NPerLastName, NPerType) {
      this.selectRow.NPerID = NPerID;
      this.selectRow.NPerName = NPerName;
      this.selectRow.NPerLastName = NPerLastName;
      this.selectRow.NPerType = NPerType;
    },

    SelectHesab() {
      if (this.selectRow.NPerID == 0) {
        this.$store.dispatch("notify", {
          notText:
            "حسابی در حالت انتخاب نیست !\nلطفا ابتدا یکی از حساب ها را در حالت انتخاب قرار دهید .",
          timeOut: 2500,
        });
      } else {
        this.NPerIDSearch = [];
        // بستن مودال
        $("#modal-taraf-hesab").modal("hide");
      }
    },

    setFocusTextSearch(value) {
      setTimeout(() => {
        $("#textSearchTarafHesab").focus();
        if (value != "") {
          $("#textSearchTarafHesab").val(value);
          $("#textSearchTarafHesab").select();
          this.filterData('Search');
        }
      }, 200);
    },
    // تابع مدیریت کلید میانبرها داخل سند
    hotKeyChecker(keyvalue) {
      if (this.TbPersonDataFilter.length > 0) {
        if (keyvalue.key === "ArrowUp" || keyvalue.key === "ArrowDown") {
          let index = this.TbPersonDataFilter.findIndex(
            (itme) => itme.NPerID == this.selectRow.NPerID
          );
          if (index != -1) {
            if (keyvalue.key === "ArrowUp") {
              if (index > 0) {
                this.selectRowVal(
                  this.TbPersonDataFilter[index - 1].NPerID,
                  this.TbPersonDataFilter[index - 1].NPerName,
                  this.TbPersonDataFilter[index - 1].NPerLastName,
                  this.TbPersonDataFilter[index - 1].NPerType
                );
                $("#traf-" + this.TbPersonDataFilter[index - 1].NPerID).scrollintoview({
                  duration: 100,
                  //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
                });
                this.indexRow = index - 1;
              }
            } else {
              if (index + 1 < this.TbPersonDataFilter.length) {
                this.selectRowVal(
                  this.TbPersonDataFilter[index + 1].NPerID,
                  this.TbPersonDataFilter[index + 1].NPerName,
                  this.TbPersonDataFilter[index + 1].NPerLastName,
                  this.TbPersonDataFilter[index + 1].NPerType
                );
                $("#traf-" + this.TbPersonDataFilter[index + 1].NPerID).scrollintoview({
                  duration: 100,
                  //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
                });
                this.indexRow = index + 1;
              }
            }
          } else {
            this.selectRowVal(
              this.TbPersonDataFilter[0].NPerID,
              this.TbPersonDataFilter[0].NPerName,
              this.TbPersonDataFilter[0].NPerLastName,
              this.TbPersonDataFilter[0].NPerType
            );
            this.indexRow = 0;
          }
        }
        // انتخاب سطر و بستن پنجره
        if (keyvalue.key === "F4") {
          this.SelectHesab();
        }
      }
    },
  },
  created() {
    this.getTbPersonData();
    BusEvent.$on("setFocusetextSearchTarafHesab", this.setFocusTextSearch);
    BusEvent.$on("keyPressValue", this.hotKeyChecker);
  },
  beforeDestroy() {
    BusEvent.$off("setFocusetextSearchTarafHesab", this.setFocusTextSearch);
    BusEvent.$off("keyPressValue", this.hotKeyChecker);
  },
};
</script>

<style scoped>
.selRow{
  background-color: #fbff94;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/NewAccDoc/Components/ModalTarafHesab.vue